import React, { Component } from "react";

// MetisMenu
import MetisMenu from "metismenujs";
import { withRouter } from "react-router-dom";
import { Link } from "react-router-dom";

//i18n
import { withTranslation } from "react-i18next";

import { connect } from "react-redux";
import {
  changeLayout,
  changeLayoutWidth,
  changeSidebarTheme,
  changeSidebarType,
  changePreloader,
} from "../../store/actions";

// ACM - Permission Service
import { hasModuleAccess, isSuperAdmin } from "../../services/PermissionService";

class SidebarContent extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this.initMenu();
  }

  componentDidUpdate(prevProps) {
    if (this.props.type !== prevProps.type) {
      this.initMenu();
    }
    if (this.props.location.pathname !== prevProps.location.pathname) {
      // Delay to let MetisMenu finish any pending DOM updates
      setTimeout(() => this.activateMenu(), 0);
    }
  }

  initMenu() {
    new MetisMenu("#side-menu");
    // MetisMenu initializes asynchronously - defer activation
    setTimeout(() => this.activateMenu(), 100);
  }

  activateMenu() {
    var ul = document.getElementById("side-menu");
    if (!ul) return;

    // 1. Clear ALL previous active/highlight states
    ul.querySelectorAll(".mm-active").forEach(function(el) {
      el.classList.remove("mm-active");
    });
    ul.querySelectorAll(".active").forEach(function(el) {
      el.classList.remove("active");
    });

    // 2. Collapse ALL open submenus
    ul.querySelectorAll(".mm-show").forEach(function(el) {
      el.classList.remove("mm-show");
    });

    // 3. Find the menu link matching current URL
    var matchingMenuItem = null;
    var currentPath = this.props.location.pathname;
    var items = ul.getElementsByTagName("a");
    for (var i = 0; i < items.length; ++i) {
      // Skip parent toggle links (href="#") - their .pathname equals the current page
      if (items[i].getAttribute("href") === "#") continue;
      if (currentPath === items[i].pathname) {
        matchingMenuItem = items[i];
        break;
      }
    }

    // 4. Activate the matching item and expand its parent menu
    if (matchingMenuItem) {
      this.activateParentDropdown(matchingMenuItem);
    }
  }

  activateParentDropdown = (item) => {
    // Highlight the active link
    item.classList.add("active");

    // Walk up the DOM tree to expand parent menus
    const li = item.parentElement; // <li>
    if (!li) return;
    li.classList.add("mm-active");

    const submenu = li.parentElement; // <ul class="sub-menu">
    if (!submenu) return;

    // Only add mm-show if this is actually a sub-menu (not the root)
    if (submenu.classList.contains("sub-menu")) {
      submenu.classList.add("mm-show");

      const parentLi = submenu.parentElement; // parent <li>
      if (parentLi) {
        parentLi.classList.add("mm-active");
        // Highlight the parent toggle link (the "has-arrow" anchor)
        const parentLink = parentLi.querySelector(":scope > a");
        if (parentLink) {
          parentLink.classList.add("mm-active");
        }
      }
    }
  };

  render() {
    return (
      <React.Fragment>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            {/* Dashboard - DASHBOARD module */}
            {hasModuleAccess('DASHBOARD') && (
              <li>
                <Link to="/dashboard" className="waves-effect">
                  <i className="ri-dashboard-line"></i>
                  <span className="badge badge-pill badge-success float-right"></span>
                  <span className="ml-1">{this.props.t("Dashboard")}</span>
                </Link>
              </li>
            )}

            {(hasModuleAccess('FOOD') || hasModuleAccess('ROOM') || hasModuleAccess('TABLE') || hasModuleAccess('TAXI') || hasModuleAccess('TRANSPORTATION')) && (
              <li className="menu-title">{this.props.t("Operations")}</li>
            )}

            {/* Food - FOOD module */}
            {hasModuleAccess('FOOD') && (
              <li>
                <a href="#" className="has-arrow waves-effect">
                  <i className="fas fa-utensils"></i>
                  <span className="ml-1">{this.props.t("Food")}</span>
                </a>
                <ul className="sub-menu">
                  <li>
                    <Link to="Foodcuisine">{this.props.t("Foodcuisine")}</Link>
                  </li>
                  <li>
                    <Link to="FoodAddOn">{this.props.t("FoodAddOn")}</Link>
                  </li>
                  <li>
                    <Link to="Food">{this.props.t("Food")}</Link>
                  </li>
                  <li>
                    <Link to="FoodOrder">{this.props.t("FoodOrder")}</Link>
                  </li>
                  <li>
                    <Link to="FoodSettings">{this.props.t("FoodSettings")}</Link>
                  </li>
                </ul>
              </li>
            )}

            {/* Rooms - ROOM module */}
            {hasModuleAccess('ROOM') && (
              <li>
                <a href="#" className="has-arrow waves-effect">
                  <i className="fas fa-person-booth"></i>
                  <span className="ml-1">{this.props.t("Rooms")}</span>
                </a>
                <ul className="sub-menu">
                  <li>
                    <Link to="RoomFeature">{this.props.t("RoomFeature")}</Link>
                  </li>
                  <li>
                    <Link to="RoomHospitalityService">
                      {this.props.t("RoomHospitalityService")}
                    </Link>
                  </li>
                  <li>
                    <Link to="AmenityType">{this.props.t("AmenityType")}</Link>
                  </li>
                  <li>
                    <Link to="Amenities">{this.props.t("Amenities")}</Link>
                  </li>
                  <li>
                    <Link to="RoomType">{this.props.t("RoomType")}</Link>
                  </li>
                  <li>
                    <Link to="Room">{this.props.t("Room")}</Link>
                  </li>
                  <li>
                    <Link to="RoomCancel">{this.props.t("RoomCancel")}</Link>
                  </li>
                  <li>
                    <Link to="Booking">{this.props.t("Booking")}</Link>
                  </li>
                  <li>
                    <Link to="/rooms/units">{this.props.t("Room stock")}</Link>
                  </li>
                  <li>
                    <Link to="/rooms/availability">{this.props.t("Availability")}</Link>
                  </li>
                </ul>
              </li>
            )}

            {/* Table Booking - TABLE module */}
            {hasModuleAccess('TABLE') && (
              <li>
                <a href="#" className="has-arrow waves-effect">
                  <i className="ri-calendar-check-line"></i>
                  <span className="ml-1">{this.props.t("Table Booking")}</span>
                </a>
                <ul className="sub-menu">
                  <li>
                    <Link to="Table">{this.props.t("Tables")}</Link>
                  </li>
                  <li>
                    <Link to="TableBooking">{this.props.t("Reservations")}</Link>
                  </li>
                  <li>
                    <Link to="/outlets">{this.props.t("Restaurants & bars")}</Link>
                  </li>
                </ul>
              </li>
            )}

            {/* Transport - TRANSPORTATION module (includes Driver Management) */}
            {hasModuleAccess('TRANSPORTATION') && (
              <li>
                <a href="#" className="has-arrow waves-effect">
                  <i className="ri-car-line"></i>
                  <span className="ml-1">{this.props.t("Transport")}</span>
                </a>
                <ul className="sub-menu">
                  <li>
                    <Link to="/transport/requests">{this.props.t("Requests")}</Link>
                  </li>
                  <li>
                    <Link to="/transport/services">{this.props.t("Services")}</Link>
                  </li>
                  <li>
                    <Link to="/transport/vehicle-types">{this.props.t("Vehicle Types")}</Link>
                  </li>
                  <li>
                    <Link to="/transport/service-tiers">{this.props.t("Service Tiers")}</Link>
                  </li>
                  <li>
                    <Link to="/transport/drivers">{this.props.t("Drivers")}</Link>
                  </li>
                  <li>
                    <Link to="/transport/settings">{this.props.t("Settings")}</Link>
                  </li>
                </ul>
              </li>
            )}

            {/* Taxi - TAXI module */}
            {hasModuleAccess('TAXI') && (
              <li>
                <Link to="Taxi" className=" waves-effect">
                  <i className="fa fa-taxi"></i>
                  <span className="ml-1">{this.props.t("Taxi")}</span>
                </Link>
              </li>
            )}

            {(hasModuleAccess('CHAT') || hasModuleAccess('LOYALTY') || hasModuleAccess('NOTIFICATION') || hasModuleAccess('USERS')) && (
              <li className="menu-title">{this.props.t("Customers")}</li>
            )}

            {/* Users - USERS module */}
            {hasModuleAccess('USERS') && (
              <li>
                <a href="#" className="has-arrow waves-effect">
                  <i className="fas fa-user"></i>
                  <span className="ml-1">{this.props.t("Users")}</span>
                </a>
                <ul className="sub-menu">
                  <li>
                    <Link to="DeliveryBoy">{this.props.t("DeliveryBoy")}</Link>
                  </li>
                  <li>
                    <Link to="User">{this.props.t("User")}</Link>
                  </li>
                </ul>
              </li>
            )}

            {/* Loyalty Program - LOYALTY module */}
            {hasModuleAccess('LOYALTY') && (
              <li>
                <a href="#" className="has-arrow waves-effect">
                  <i className="ri-gift-line"></i>
                  <span className="ml-1">{this.props.t("Loyalty")}</span>
                </a>
                <ul className="sub-menu">
                  <li>
                    <Link to="/loyalty/accounts">{this.props.t("Members")}</Link>
                  </li>
                  <li>
                    <Link to="/loyalty/settings">{this.props.t("Settings")}</Link>
                  </li>
                </ul>
              </li>
            )}

            {/* Chat - CHAT module */}
            {hasModuleAccess('CHAT') && (
              <li>
                <Link to="ChatList" className=" waves-effect">
                  <i className="fa fa-comments"></i>
                  <span className="ml-1">{this.props.t("ChatList")}</span>
                </Link>
              </li>
            )}

            {/* Notification - NOTIFICATION module */}
            {hasModuleAccess('NOTIFICATION') && (
              <li>
                <Link to="Notification" className=" waves-effect">
                  <i className="fa fa-bell"></i>
                  <span className="ml-1">{this.props.t("Notification")}</span>
                </Link>
              </li>
            )}

            {/* Manage Notification - NOTIFICATION module */}
            {hasModuleAccess('NOTIFICATION') && (
              <li>
                <Link to="ManageNotification" className=" waves-effect">
                  <i className="fa fa-wrench"></i>
                  <span className="ml-1">
                    {this.props.t("ManageNotification")}
                  </span>
                </Link>
              </li>
            )}

            {(hasModuleAccess('BANNER') || hasModuleAccess('COUPON') || hasModuleAccess('CROSSSELL')) && (
              <li className="menu-title">{this.props.t("Marketing")}</li>
            )}

            {/* Coupon Management - COUPON module */}
            {hasModuleAccess('COUPON') && (
              <li>
                <Link to="/coupon" className=" waves-effect">
                  <i className="ri-coupon-3-line"></i>
                  <span className="ml-1">{this.props.t("Coupons")}</span>
                </Link>
              </li>
            )}

            {/* Banner Management - BANNER module */}
            {hasModuleAccess('BANNER') && (
              <li>
                <Link to="/banner" className=" waves-effect">
                  <i className="ri-image-2-line"></i>
                  <span className="ml-1">{this.props.t("Banners")}</span>
                </Link>
              </li>
            )}

            {/* Attraction - ATTRACTION module */}
            {hasModuleAccess('ATTRACTION') && (
              <li>
                <Link to="Attraction" className=" waves-effect">
                  <i className="ri-artboard-2-line"></i>
                  <span className="ml-1">{this.props.t("Attraction")}</span>
                </Link>
              </li>
            )}

            {/* Cross-sell offers - CROSSSELL module */}
            {hasModuleAccess('CROSSSELL') && (
              <li>
                <Link to="/crosssell" className=" waves-effect">
                  <i className="ri-price-tag-3-line"></i>
                  <span className="ml-1">{this.props.t("Cross-sell")}</span>
                </Link>
              </li>
            )}

            {(hasModuleAccess('ANALYTICS') || hasModuleAccess('ATTRACTION') || hasModuleAccess('PAYMENTS')) && (
              <li className="menu-title">{this.props.t("Finance & Insights")}</li>
            )}

            {/* Payments & Transactions - PAYMENTS module */}
            {hasModuleAccess('PAYMENTS') && (
              <li>
                <Link to="/payments/transactions" className=" waves-effect">
                  <i className="ri-bank-card-line"></i>
                  <span className="ml-1">{this.props.t("Transactions")}</span>
                </Link>
              </li>
            )}

            {/* Analytics - ANALYTICS module */}
            {hasModuleAccess('ANALYTICS') && (
              <li>
                <a href="#" className="has-arrow waves-effect">
                  <i className="ri-bar-chart-box-line"></i>
                  <span className="ml-1">{this.props.t("Analytics")}</span>
                </a>
                <ul className="sub-menu">
                  <li>
                    <Link to="/analytics">{this.props.t("Dashboard")}</Link>
                  </li>
                  <li>
                    <Link to="/analytics/revenue">{this.props.t("Revenue")}</Link>
                  </li>
                  <li>
                    <Link to="/analytics/food">{this.props.t("Food")}</Link>
                  </li>
                  <li>
                    <Link to="/analytics/room">{this.props.t("Rooms")}</Link>
                  </li>
                  <li>
                    <Link to="/analytics/table">{this.props.t("Tables")}</Link>
                  </li>
                  <li>
                    <Link to="/analytics/transport">{this.props.t("Transport")}</Link>
                  </li>
                  <li>
                    <Link to="/analytics/coupon">{this.props.t("Coupons")}</Link>
                  </li>
                  <li>
                    <Link to="/analytics/users">{this.props.t("Users")}</Link>
                  </li>
                </ul>
              </li>
            )}

            {/* Activity Logs - Super Admin only */}
            {isSuperAdmin() && (
              <li>
                <Link to="/activity-logs" className=" waves-effect">
                  <i className="ri-file-list-3-line"></i>
                  <span className="ml-1">{this.props.t("Activity Logs")}</span>
                </Link>
              </li>
            )}

            {(hasModuleAccess('TEAM') || isSuperAdmin()) && (
              <li className="menu-title">{this.props.t("Administration")}</li>
            )}

            {/* Branch Management - Super Admin Only */}
            {isSuperAdmin() && (
              <li>
                <Link to="/branches" className=" waves-effect">
                  <i className="ri-store-2-line"></i>
                  <span className="ml-1">{this.props.t("Branches")}</span>
                </Link>
              </li>
            )}

            {/* Master Catalog - Super Admin Only */}
            {isSuperAdmin() && (
              <li>
                <Link to="/master-catalog" className=" waves-effect">
                  <i className="bx bx-list-ul"></i>
                  <span className="ml-1">{this.props.t("Master Catalog")}</span>
                </Link>
              </li>
            )}

            {/* Team Management - super admin + branch admins with TEAM permission */}
            {hasModuleAccess('TEAM') && (
              <li>
                <Link to="/team" className=" waves-effect">
                  <i className="fas fa-users-cog"></i>
                  <span className="ml-1">{this.props.t("Team")}</span>
                </Link>
              </li>
            )}

            {/* App Version Settings - Super Admin Only */}
            {isSuperAdmin() && (
              <li>
                <Link to="/AppVersionSettings" className=" waves-effect">
                  <i className="ri-smartphone-line"></i>
                  <span className="ml-1">App Version</span>
                </Link>
              </li>
            )}
          </ul>
        </div>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  return { ...state.Layout };
};

export default withRouter(
  connect(mapStatetoProps, {
    changeLayout,
    changeSidebarTheme,
    changeSidebarType,
    changeLayoutWidth,
    changePreloader,
  })(withTranslation()(SidebarContent))
);
